export interface LlmRunSessionStorage {
  hiddenOutputs: string[];
  hiddenInputs: string[];
  hiddenResults: string[];
}

export class LlmRunComparisonSessionStorage {
  private storageKey = "llmRunComparison";

  constructor() {
    this.initialiseLlmRunCompareSessionStorage();
  }

  private initialiseLlmRunCompareSessionStorage() {
    const sessionObject = sessionStorage.getItem("llmRunComparison");
    let parsedSessionObject: Partial<LlmRunSessionStorage> = {};

    if (sessionObject) {
      parsedSessionObject = JSON.parse(sessionObject);
    }

    if (!parsedSessionObject.hiddenOutputs) {
      parsedSessionObject.hiddenOutputs = [];
    }

    if (!parsedSessionObject.hiddenInputs) {
      parsedSessionObject.hiddenInputs = [];
    }

    if (!parsedSessionObject.hiddenResults) {
      parsedSessionObject.hiddenResults = [];
    }

    sessionStorage.setItem(
      "llmRunComparison",
      JSON.stringify(parsedSessionObject),
    );
  }

  private getSessionObject(): LlmRunSessionStorage {
    const sessionObject = sessionStorage.getItem(this.storageKey);

    if (!sessionObject) {
      throw new Error("LlmRunSessionStorage is not initialized properly.");
    }

    return JSON.parse(sessionObject) as LlmRunSessionStorage;
  }

  private updateSession(updatedSession: LlmRunSessionStorage): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(updatedSession));
  }

  getHiddenOutputs(): string[] {
    return this.getSessionObject().hiddenOutputs;
  }

  setHiddenOutputs(hiddenOutputs: string[]): void {
    const session = this.getSessionObject();
    session.hiddenOutputs = hiddenOutputs;
    this.updateSession(session);
  }

  getHiddenInputs(): string[] {
    return this.getSessionObject().hiddenInputs;
  }

  setHiddenInputs(hiddenInputs: string[]): void {
    const session = this.getSessionObject();
    session.hiddenInputs = hiddenInputs;
    this.updateSession(session);
  }

  getHiddenResults(): string[] {
    return this.getSessionObject().hiddenResults;
  }

  setHiddenResults(hiddenResults: string[]): void {
    const session = this.getSessionObject();
    session.hiddenResults = hiddenResults;
    this.updateSession(session);
  }
}
